import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import injectSheet from 'react-jss'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

const styles = () => {
  return {
    page: {
      height: '100vh',
      overflowY: 'auto',
      position: 'fixed',
      top: 0,
      width: '100%',
      '-webkit-overflow-scrolling': 'touch',
      transition: 'transform 0.25s ease-in-out',
      backgroundColor: '#FAFAFA',
    },
    pageEnter: {
      transform: 'translate(100%, 0)',
    },
    pageEnterActive: {
      transform: 'translate(0, 0)',
    },
    pageExit: {
      transform: 'translate(100%, 0)',
    },
    pagePrevEnter: {
      transform: 'translate(0, 0)',
    },
    pagePrevEnterActive: {
      transform: 'translate(0, 0)',
    },
    pagePrevExit: {
      transform: 'translate(-100%, 0)',
    },
  }
}

@withRouter
@injectSheet(styles)
class RouteTransitionWrapper extends Component {
  render() {
    const {
      classes, children, history,
    } = this.props
    return (
      <TransitionGroup component={'main'}>
        <CSSTransition
          // key={location.pathname}
          key={1}
          classNames={{
            enter: history.action === 'POP' ? classes.pagePrevEnter : classes.pageEnter,
            enterActive:
              history.action === 'POP' ? classes.pageEnterActive : classes.pagePrevEnterActive,
            exit: history.action === 'POP' ? classes.pagePrevExit : classes.pageExit,
          }}
          timeout={{
            enter: 250,
            exit: 250,
          }}
          appear={true}
          exit={false}
        >
          <section className={classes.page}>{children}</section>
        </CSSTransition>
      </TransitionGroup>
    )
  }
}

RouteTransitionWrapper.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
  history: PropTypes.shape({
    action: PropTypes.string.isRequired,
  }),
}

export default RouteTransitionWrapper
